module.exports = __webpack_public_path__ + "img/Misi Working Style-Icon Social0.0e852ad1.png";